import React, { useState, useEffect, useRef } from 'react';
import { useHistory, NavLink, useRouteMatch, generatePath } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import styles from './Detail.module.less';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import GameLink from '../../components/GameLink';
import Loading from '../../components/Loading';
import LoadError from '../../components/LoadError';

import { GAME_RANK_MORE } from '../../../../config';
import { createAxios } from '../../../../utils/utils';
import useLog from '../../hooks/useLog';
import { scrollClear, scrollUse } from '../../../../actions/game';

const LIMIT = 10;

export default ({ source: sourceProp, code, ranks }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [, track] = useLog();
  const { path } = useRouteMatch();

  const [apps, setApps] = useState([]);

  const [hasError, setHasError] = useState(false);
  const [loadmore, setLoadmore] = useState(0);

  const $this = useRef({
    fetching: false,
    isEnd: false,
    skip: 0,
    code: null,
  });

  useEffect(() => {
    if ($this.current.code === null) return;
    if ($this.current.isEnd || $this.current.fetching) return;

    let limit = sessionStorage.getItem('GAME_TOP_LIMIT');
    if (limit !== null) {
      sessionStorage.removeItem('GAME_TOP_LIMIT');
    }

    $this.current.fetching = true;
    createAxios().then(axios => {
      axios
        .get(GAME_RANK_MORE, {
          params: {
            code: $this.current.code,
            limit: history.action === 'POP' && limit !== null ? limit : LIMIT,
            skip: $this.current.skip,
          },
        })
        .then(res => {
          $this.current.fetching = false;
          if (
            res.data.status !== 0 ||
            !res.data.data ||
            !res.data.data.apps ||
            res.data.data.apps.length <= 0
          )
            throw new Error('no apps.');

          if ($this.current.skip === 0) {
            dispatch(scrollUse(history.action));
          }
          $this.current.skip += res.data.data.apps.length;
          setApps(apps => {
            let result = [...apps, ...res.data.data.apps];
            if (result.length >= res.data.data.count) {
              $this.current.isEnd = true;
            }
            return result;
          });
        })
        .catch(() => {
          $this.current.fetching = false;
          setHasError(true);
        });
    });
  }, [loadmore]);

  useEffect(() => {
    setApps([]);
    $this.current = {
      fetching: false,
      isEnd: false,
      skip: 0,
      code,
    };
    setLoadmore(Date.now());
  }, [code]);

  useEffect(() => {
    let scroller = document.querySelector('#game_content') || document.createElement('div');

    const _scrollHandle = e => {
      if (e.target.offsetHeight + e.target.scrollTop + 1 >= e.target.scrollHeight) {
        setLoadmore(Date.now());
      }
    };

    scroller.addEventListener('scroll', _scrollHandle);
    return () => {
      scroller.removeEventListener('scroll', _scrollHandle);
    };
  }, []);

  const _track = code => {
    track(1, `${sourceProp}||${code}`);
    dispatch(scrollClear());
  };

  useEffect(() => {
    return () => {
      let limit = $this.current.skip;
      limit > 0 && sessionStorage.setItem('GAME_TOP_LIMIT', limit);
    };
  }, []);

  return (
    <div className={styles.Detail}>
      <nav className="menu">
        {ranks.map(rank => (
          <NavLink
            key={rank.code}
            onClick={() => _track(rank.code)}
            to={generatePath(path, {
              code: rank.code,
            })}
          >
            {rank.desc}
          </NavLink>
        ))}
      </nav>
      {!hasError && apps.length > 0 && (
        <nav className="list">
          {apps.map(app => {
            let source = `${sourceProp}||${code}`;
            let id = app.softID || '';
            if (app.androidType === '1') {
              id = app.packageName;
            }

            return (
              <GameLink
                key={id}
                info={{
                  targetType: '1',
                  appInfo: app,
                }}
                source={source}
                logInfo={{
                  category: 'C',
                  action: 'Game_Non_Button',
                  params: {
                    id,
                    type: 'soft',
                    source,
                  },
                  bizInfo: app.bizInfo,
                }}
              >
                <Icon app={app} />
                <div className="name">
                  <h1 title={app.softName}>{app.softName}</h1>
                  <p>{app.introduction}</p>
                </div>
                <div className="count">{app.downloadCount || '1万次'}安装</div>
                <div className="size">{app.installFileSize}</div>
                <Button soft={app} size="big" logInfo={{ source }} />
              </GameLink>
            );
          })}
        </nav>
      )}
      {hasError && <LoadError offset={-60} />}
      {!hasError && apps.length <= 0 && <Loading offset={-60} />}
      {!hasError && apps.length > 0 && $this.current.fetching && (
        <p className="loading">正在加载中…</p>
      )}
      {!hasError && apps.length > 0 && $this.current.isEnd && (
        <p className="nothing">没有更多了~</p>
      )}
    </div>
  );
};
